import { functions } from "../firebase";

export type McpToken = {
  id: string;
  label: string;
  scope: string;
  createdAt?: number;
  lastUsedAt?: number;
  disabled: boolean;
};

export type CreatedMcpToken = {
  token: string;
  connectorUrl: string;
  label: string;
  scope: string;
};

export const createMcpToken = async (
  communityId: string,
  label: string
): Promise<CreatedMcpToken> => {
  const callable = functions.httpsCallable("createMcpToken");
  const result = await callable({ communityId, label });
  return result.data as CreatedMcpToken;
};

export const listMcpTokens = async (
  communityId: string
): Promise<{ tokens: McpToken[]; connectorUrl: string }> => {
  const callable = functions.httpsCallable("listMcpTokens");
  const result = await callable({ communityId });
  return result.data as { tokens: McpToken[]; connectorUrl: string };
};

export const revokeMcpToken = async (
  communityId: string,
  id: string
): Promise<{ revoked: number }> => {
  const callable = functions.httpsCallable("revokeMcpToken");
  const result = await callable({ communityId, id });
  return result.data as { revoked: number };
};
